export default "__VITE_ASSET__qGq2$LVG__"